import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PagePaths } from '@/routes/page-paths';

export interface SendPageLocationState {
  returnTo: string;
  returnState: unknown;
  initialCoinType?: string;
}

interface UseOpenSendOptions {
  isMobile: boolean;
  onOpenModal: () => void;
}

export const useOpenSend = ({ isMobile, onOpenModal }: UseOpenSendOptions) => {
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(
    (initialCoinType?: string) => {
      if (!isMobile) {
        onOpenModal();
        return;
      }

      const state: SendPageLocationState = {
        returnTo: `${location.pathname}${location.search}`,
        returnState: location.state ?? null,
        ...(initialCoinType ? { initialCoinType } : {}),
      };

      navigate(PagePaths.portfolioSend, { state });
    },
    [isMobile, location.pathname, location.search, location.state, navigate, onOpenModal],
  );
};
